import { configManagerCloudServicesApi as api } from '../configManagerCloudServicesApi';
import {
  GetCurrentUserAccountsApiArg,
  GetCurrentUserAccountsApiResponse,
  GetCurrentUserProfileApiArg,
  GetCurrentUserProfileApiResponse,
  GetUserProfileByIdApiArg,
  GetUserProfileByIdApiResponse,
  ListAllUserProfilesApiArg,
  ListAllUserProfilesApiResponse,
  UpdateCurrentUserProfileApiArg,
  UpdateCurrentUserProfileApiResponse,
  UpdateUserProfileStatusApiArg,
  UpdateUserProfileStatusApiResponse,
} from './types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    getCurrentUserProfile: build.query<GetCurrentUserProfileApiResponse, GetCurrentUserProfileApiArg>({
      query: () => ({ url: `/config-manager-cloud-services/api/v1/user-profiles/current` }),
      providesTags: ['USER_PROFILE'],
    }),
    updateCurrentUserProfile: build.mutation<UpdateCurrentUserProfileApiResponse, UpdateCurrentUserProfileApiArg>({
      query: queryArg => ({
        url: `/config-manager-cloud-services/api/v1/user-profiles/current`,
        method: 'PUT',
        body: queryArg.updates,
      }),
      invalidatesTags: ['USER_PROFILE', 'ACCOUNT_PROFILE', 'SUBSCRIPTIONS'],
    }),
    getCurrentUserAccounts: build.query<GetCurrentUserAccountsApiResponse, GetCurrentUserAccountsApiArg>({
      query: () => ({ url: `/config-manager-cloud-services/api/v1/user-profiles/current/accounts` }),
      providesTags: ['USER_PROFILE'],
    }),
    getUserProfileById: build.query<GetUserProfileByIdApiResponse, GetUserProfileByIdApiArg>({
      query: queryArg => ({ url: `/config-manager-cloud-services/api/v1/user-profiles/${queryArg.userId}` }),
      providesTags: ['USER_PROFILE'],
    }),
    listAllUserProfiles: build.query<ListAllUserProfilesApiResponse, ListAllUserProfilesApiArg>({
      query: () => ({ url: `/config-manager-cloud-services/api/v1/user-profiles/` }),
      providesTags: ['USER_PROFILE'],
    }),
    updateUserProfileStatus: build.mutation<UpdateUserProfileStatusApiResponse, UpdateUserProfileStatusApiArg>({
      query: queryArg => ({
        url: `/config-manager-cloud-services/api/v1/user-profiles/${queryArg.userId}/status`,
        method: 'PUT',
        params: {
          new_status: queryArg.newStatus,
        },
      }),
      invalidatesTags: ['USER_PROFILE'],
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as userProfilesApi };

export const {
  useGetCurrentUserProfileQuery,
  useUpdateCurrentUserProfileMutation,
  useGetCurrentUserAccountsQuery,
  useGetUserProfileByIdQuery,
  useListAllUserProfilesQuery,
  useUpdateUserProfileStatusMutation,
} = injectedRtkApi;
